<template>
  <a-popover
    v-if="canEdit"
    trigger="click"
  >
    <template #content>
      <a-tooltip>
        <template #title>
          {{ $t('okr.autoSaveOnBlur') }}
        </template>
        <a-input-number
          v-model:value="form.weight"
          :min="0"
          :max="100"
          :formatter="value => `${value}`"
          class="input"
          :step="1"
          :precision="0"
          @blur="e => onBlur(+e.target.value)"
        />
        <span class="after">/100</span>
      </a-tooltip>
    </template>
    <span
      :class="{ weightAlarmStyle: weightAlarmStyle, pointer: canEdit }"
    >{{ $t('shared.proportion') }}: {{ objective.weight }}/100</span>
  </a-popover>
  <span v-else>{{ $t('shared.proportion') }}: {{ objective.weight }}/100</span>
</template>
<script>
import { toRef, watch } from 'vue'
import { updateObjective } from '@/api/okr'
import { useI18n } from 'vue-i18n'
import { message } from 'ant-design-vue'

export default {
  props: {
    canEdit: {
      type: Boolean,
      required: true
    },
    objective: {
      type: Object,
      default: () => null
    },
    weightAlarmStyle: {
      type: Boolean,
      required: true
    }
  },
  emits: ['weight-updated', 'set-weight-alarm-style-false'],
  setup (props, { emit }) {
    const { t } = useI18n()
    const form = toRef(props, 'objective')
    function onBlur (weight) {
      updateObjective(props.objective.id, {
        weight
      }).then(() => {
        message.success(t('okr.weightDialog.successMessage'))
        form.value.weight = weight
        emit('weight-updated')
      })
    }
    watch(() => form.value.weight, val => {
      emit('set-weight-alarm-style-false')
    })
    return {
      form,
      onBlur
    }
  }
}
</script>
<style lang="less" scoped>
.weightAlarmStyle {
  color: red;
}
.pointer {
  cursor: pointer;
}

.input {
  width: 68px;
}

.after {
  padding-left: 6px;
}
</style>
